import { defineAsyncComponent } from 'vue';

export const AppProductPageAsync = defineAsyncComponent(() => import('@/shared/components/AppProductPage/AppProductPage.vue'));
